import Vue from "vue";

export default {
  // Get employee projects
  getEmployeeProjects({ commit, state }) {
    const params = {
      page: state.currentPage,
      perPage: state.perPage,
      ...(state.searchQuery != "" && { search_query: state.searchQuery }),
    };
    commit("tableLoading", true);
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/hrm/projects/get-employee-projects`, { params })
        .then(response => {
          commit("tableLoading", false);
          commit("setEmployeeProjects", response.data);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoading", false);
          reject(error);
        });
    });
  },

  getTasks({ commit, state }, payload) {
    const params = {
      page: state.currentPage,
      perPage: state.perPage,
      ...(payload && payload),
      ...(state.searchQuery != "" && { search_query: state.searchQuery }),
    };
    commit("tableLoading", true);
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/hrm/projects/tasks`, { params })
        .then(response => {
          commit("tableLoading", false);
          commit("setTasks", response.data);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoading", false);
          reject(error);
        });
    });
  },
  // Get tasks by project
  getTasksByProject({ commit, state }, projectId) {
    const params = {
      page: state.currentPage,
      perPage: state.perPage,
      ...(state.searchQuery != "" && { search_query: state.searchQuery }),
    };
    commit("tableLoading", true);
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/hrm/projects/tasks/get-tasks-by-project/${projectId}`, {
          params,
        })
        .then(response => {
          commit("tableLoading", false);
          commit("setTasksByProject", response.data.results);
          commit("paginationTotal", response.data.total);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoading", false);
          reject(error);
        });
    });
  },

  // Get one task
  getTaskById({ commit }, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/hrm/projects/tasks/${id}`)
        .then(response => {
          commit("setTask", response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Update project status
  updateProjectStatus(_, payload) {
    const { id, status } = payload;
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/hrm/projects/update-project-status/${id}`, { status })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
